<template>
    <div style="width: 100%;scroll-behavior: smooth;">
        <div style="margin-bottom: 15px;width: 1120px;margin: 0 auto;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/', query: {tab: 0} }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/NQI' }">NQI站点</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/NQIDetail' }">站点信息</el-breadcrumb-item>
                <el-breadcrumb-item>淄博市建陶产品质量基础设施一站式服务平台</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="top-bottom" style="margin-top: 10px;">
            <img src="../../assets/img/taoci/logo.png" style="margin-left: -2px;" alt="">
        </div>
        <!-- <div style="margin: 10px 23%;min-width: 680px;"> -->
        <div style="margin: 0 auto;width: 1120px;">
            <div class="page-container">
                <!-- 政策文件 -->
                <section class="section">
                <div class="section-title">
                    <p class="en-title">POLICY PAPERS</p>
                    <h2 class="cn-title">政策文件</h2>
                </div>
                <div class="list-group">
                    <div class="list-item" v-for="(item, index) in policyList" :key="index" @click="zhengceFile(item.files)">
                      <img class="icon-placeholder" src="../../assets/img/buxiugang/file.png" style="width: 17px;height: 20px;" alt="">
                      <!-- <span class="icon-placeholder"></span> -->
                      <span class="text">{{ item.name }}</span>
                    </div>
                </div>
                </section>

                <!-- 标准 -->
                <section class="section">
                <div class="section-title">
                    <p class="en-title">STANDARD DOCUMENTS</p>
                    <h2 class="cn-title">标准</h2>
                </div>
                <div class="list-group">
                    <div class="list-group">
                        <div class="list-item with-date" v-for="(item, index) in standardList" :key="index">
                            <div class="left">
                            <!-- <img class="icon-placeholder" src="../../assets/img/buxiugang/bz.png" style="width: 17px;height: 20px;" alt=""> -->
                                <!-- <span class="icon-placeholder h-icon"></span> -->
                            <div style="display: flex;flex-direction: column;line-height: 1.5;">
                                <span class="text" style="font-size: 16px;color: #4a74be;">{{ item.standardNumber }}</span>
                                <span class="text" style="font-size: 11px;color: black;">{{ item.csName }}</span>
                            </div>
                            </div>
                            <div style="display: flex;justify-content: end;width: 200px;justify-content: space-evenly;align-items: center;">
                                <span class="date">{{ item.releaseDate }}</span>
                                <span class="date" style="padding: 7px 10px;background-color: #56a0e3;color: white;font-size: 11px;border-radius: 3px;">{{ item.standardState }}</span>
                                <span class="date" style="padding: 7px 10px;background-color: #409eff;color: white;font-size: 11px;border-radius: 3px;"  @click="openDialog(item)">预览</span> 
                            </div> 
                        </div>
                    </div>
                    
                    <div style="display: flex;justify-content: center;margin-top: 20px;">
                      <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[6, 10, 15, 20]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                      </el-pagination>
                    </div>
                </div>
                </section>

                <!-- 平台服务 -->
                <section class="section">
                <div class="section-title">
                    <p class="en-title">PLATFORM SERVICE SYSTEM</p>
                    <h2 class="cn-title">平台服务</h2>
                </div>
                <div class="service-grid">
                    <div class="service-card" v-for="(item, index) in serviceList" :key="index" @click="getDialog(item)">
                    <div class="card-bg">
                        <!-- 这里可以替换为真实图片 -->
                        <img class="bg-img" :src="require(`@/assets/img/taoci/item${index + 1}.png`)" alt="">
                        <!-- <div class="card-text">{{ item.name }}</div> -->
                    </div>
                    </div>
                </div>
                </section>

                <!-- 企业标杆 -->
                <section class="section">
                <div class="section-title">
                    <p class="en-title">CORPORATE BENCHMARK</p>
                    <h2 class="cn-title">企业标杆</h2>
                </div>
                <div class="benchmark-grid">
                    <div class="benchmark-card" v-for="(item, index) in benchmarkList" :key="index">
                    <div class="card-logo">
                        <!-- Logo占位 -->
                         <img :src="getUrl(item.picture)" style="width: 180px;height: 90px;padding: 10px;" alt="">
                        <!-- <div class="logo-placeholder">NCSS</div> -->
                    </div>
                    <div class="card-info">
                        <h4 class="name">{{ item.name }}</h4>
                        <p class="info">联系方式：{{ item.phone }}</p>
                        <p class="info">地址：{{ item.address }}</p>
                    </div>
                    </div>
                </div>
                </section>
            </div>
        </div>
        <ServiceDialog
          :visible.sync="dialogShow"
          :header-img-url="imgPath"
          :title="title"
          :contentList="contentList"
          :desc="desc"
        />
        <StandardDetailDialog :dialog-visible.sync="showDialog" :source-data="nowItem" @close="handleDialogClose" />
        <InspectionTableDialog :visible.sync="showTable" @close="handleClose" />
    </div>
</template>
<script>
  import { Server,httpurl } from "@/server";
  //引入axios插件
  import axios from "axios";
  import ServiceDialog from './buxiugangDialog.vue'
  import StandardDetailDialog from './taocibiaozhun.vue'
  import InspectionTableDialog from './taociInspectionTableDialog.vue'
  export default {
    name: 'PolicyStandardPage',
    components: { ServiceDialog, StandardDetailDialog, InspectionTableDialog },
  data() {
    return {
      policyList: [],
      standardList: [],
      serviceList: [
        { 
          name: '检验检测服务', 
          img: '', 
          contentList:[
            "陶瓷砖国家标准GB/T4100所含全部检验项目检测，出具国家级试验室CMA、CNAS双C认证检验检测报告;型式检验;",
            "3C认证项目:放射性核素限量的检测;适用其它国标的细分门类建陶产品(防静电瓷砖、耐酸砖、大规格陶瓷板等)的检测;防滑性、防火等级等适老康养类检验项目的检测;工艺论证性检测。",
          ], 
          desc:'平台提供全面、精准的检测服务，确保不锈钢产品符合国家标准及行业规范，涵盖以下核心项目' 
        },
        { 
          name: '标准宣贯及制定', 
          img: '', 
          contentList:["开展标准解读与培训，协助企业制定企业/团体标准。"], 
          desc:'' 
        },
        { 
          name: '计量服务', 
          img: '', 
          contentList:["提供仪器设备校准，计量管理体系认证咨询。"], 
          desc:'' 
        },
        { 
          name: '认证认可支持:', 
          img: '', 
          contentList:["包括体系认证咨询，绿色产品认证指导等。"], 
          desc:'' 
        },
        { 
          name: '知识产权及广告商标:', 
          img: '', 
          contentList:["平台提供专利、商标、广告方面法律法规及政策咨询服务，帮助企业提升知识产权创造和转移转化运用水平。"], 
          desc:'' 
        },
        { 
          name: '技术咨询', 
          img: '', 
          contentList:["为有关生产、售后等问题提供技术解读"], 
          desc:'' 
        }
      ],
      benchmarkList: [],
      dialogShow: false,
      // 替换成你的头部图片路径
      imgPath: require('@/assets/img/buxiugang/dialog.png'),
      title:'',
      showDialog: false,
      sspt:2,
      nowItem:{},
      showTable: false,
      currentPage:1,
      pageNo:1,
      pageSize:6,
      total:0
    }
  },
  mounted() {
    this.getData()
  },
  methods:{
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val
      this.getIndustryStandardList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNo = val
      this.getIndustryStandardList()
    },
    zhengceFile(url) {
      url = this.$previewUrl + url
      window.open('','_blank')
      .document.write(`<iframe src="${url}" style="width:100%;height:100vh;border:none;"></iframe>`);
    },
    openDialog(item) {
      this.nowItem = item
      this.showDialog = true;
    },
    handleDialogClose() {
      console.log('弹窗关闭回调');
    },
    handleClose() {
      console.log('弹窗关闭回调');
    },
    getIndustryStandardList() {
      Server.getIndustryStandardList({sspt:this.sspt,pageSize:this.pageSize,pageNo:this.pageNo}).then((res) => {
          console.log(res);
          if(res.success) {
            console.log(res);
            this.total = res.result.total
            this.standardList = res.result.records || []
            
          }
        })
    },
    getData() {
        this.getIndustryStandardList()
        Server.getIndustryPolicyList({sspt:this.sspt,pageSize:-1}).then((res) => {
          console.log(res);
          if(res.success) {
            console.log(res);
            this.policyList = res.result.records || []
          }
        })
        Server.getIndustryBenchmarkList({sspt:this.sspt,pageSize:-1}).then((res) => {
          console.log(res);
          if(res.success) {
            console.log(res);
            this.benchmarkList = res.result.records || []
          }
        })
    },
    getUrl(file) {
      return this.$previewUrl + file
    },
    getDialog(item) {
      this.contentList = item.contentList
      this.desc = item.desc
      this.title = item.name
      if (item.name == '检验检测服务') {
        this.showTable = true
      } else {
        this.dialogShow = true
      }
    }
  }
}
</script>

<style scoped>
.page-container {
  padding-top: 10px;
  max-width: 1100px;
  margin: 0 auto;
  background: #ffffff;
  padding: 20px 0;
}
.section {
  margin-bottom: 40px;
}
.section-title {
  text-align: center;
  margin-bottom: 20px;
}
.en-title {
  font-size: 20px;
  color: #ddd;
  margin: 0 0 4px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.cn-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-top: -8px;
}
.list-group {
  background: #fff;
}
.list-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f5f5f5;

  background-color: #f5f7fa;
  margin: 5px 20px;
}
.list-item:last-child {
  border-bottom: none;
}
.icon-placeholder {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: #d8e4f8;
  border-radius: 2px;
  margin-right: 8px;
}
.icon-placeholder.h-icon {
  background: #c9d8f0;
  border-radius: 50%;
}
.text {
  font-size: 14px;
  color: #333;
}
.list-item.with-date {
  justify-content: space-between;
}
.list-item.with-date .left {
  display: flex;
  align-items: center;
}
.date {
  font-size: 12px;
  color: #666;
}
/* 平台服务网格 */
.service-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  padding: 0 10px;
}
.service-card {
  overflow: hidden;
}
.card-bg {
  position: relative;
  width: 100%;
  height: 140px;
  background: #e9edf5;
}
.bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.8;
}
.card-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 14px;
  text-align: center;
  text-shadow: 0 0 4px rgba(0,0,0,0.3);
}
/* 产业标杆 */
.benchmark-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  padding: 0 10px;
}
.benchmark-card {
  display: flex;
  align-items: center;
  padding: 16px;
  border: 1px solid #eee;
}
.logo-placeholder {
  width: 40px;
  height: 40px;
  background: #e0e7f3;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #3366aa;
  margin-right: 12px;
}
.name {
  font-size: 14px;
  margin: 0 0 8px;
}
.info {
  font-size: 12px;
  color: #666;
  margin: 4px 0;
}
</style>